<div
  class="language-currency-settings-container"
  [class.language-currency-settings-container-t2]="theme() === GbTheme.ThemeTwo"
>
  <div class="modal-header border-bottom-0 p-0">
    <div class="language-currency-buttons-container">
      @if (multiLingualMasterEnabled()) {
        <button
          class="primary-font-medium language-currency-button default-button"
          [class.active-button]="activeTab() === TabTypes.Language"
          [class.rounded-pill]="theme() === GbTheme.ThemeOne"
          (click)="switchTab(TabTypes.Language)"
        >
          {{ 'language.title' | translate }}
        </button>
      }

      @if (currencyConversionMasterEnabled()) {
        <button
          class="primary-font-medium language-currency-button default-button"
          [class.active-button]="activeTab() === TabTypes.Currency"
          [class.rounded-pill]="theme() === GbTheme.ThemeOne"
          (click)="switchTab(TabTypes.Currency)"
        >
          {{ 'currency.title' | translate }}
        </button>
      }
    </div>

    <div class="modal-body-header d-md-none d-flex gap-3">
      <span class="header-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
        >
          <path
            d="M17.6866 4.25C17.9491 4.25018 18.1836 4.41442 18.2735 4.66113L20.6807 11.2812H26.1241C26.3866 11.2814 26.6211 11.4457 26.711 11.6924L29.2959 18.8018C29.3461 18.9397 29.3461 19.0915 29.2959 19.2295L26.711 26.3389C26.6211 26.5856 26.3866 26.7498 26.1241 26.75H10.5791C10.1454 26.75 9.84303 26.3187 9.99125 25.9111L12.2432 19.7188H2.14164C1.70792 19.7188 1.40553 19.2875 1.55375 18.8799L3.98344 12.1982C4.03361 12.0603 4.03361 11.9085 3.98344 11.7705L1.55375 5.08887C1.40553 4.68125 1.70792 4.25 2.14164 4.25H17.6866Z"
            fill="white"
          />
          <g style="mix-blend-mode: multiply">
            <path
              d="M1.55494 5.08859C1.40672 4.68097 1.70858 4.25 2.14231 4.25H17.6872C17.9501 4.25 18.1848 4.41442 18.2746 4.66141L20.8598 11.7708C20.91 11.9088 20.91 12.06 20.8598 12.198L18.2746 19.3073C18.1848 19.5543 17.9501 19.7188 17.6872 19.7188H2.14231C1.70858 19.7188 1.40672 19.2878 1.55494 18.8802L3.98483 12.198C4.035 12.06 4.035 11.9088 3.98483 11.7708L1.55494 5.08859Z"
              class="primary-path"
              fill="#3D38D0"
            />
          </g>
          <g style="mix-blend-mode: multiply">
            <path
              d="M9.99244 12.1198C9.84422 11.7122 10.1461 11.2812 10.5798 11.2812H26.1247C26.3876 11.2812 26.6223 11.4457 26.7121 11.6927L29.2973 18.802C29.3475 18.94 29.3475 19.0912 29.2973 19.2292L26.7121 26.3386C26.6223 26.5856 26.3876 26.75 26.1247 26.75H10.5798C10.1461 26.75 9.84422 26.319 9.99244 25.9114L12.4223 19.2292C12.4725 19.0912 12.4725 18.94 12.4223 18.802L9.99244 12.1198Z"
              class="primary-medium"
              fill="#9E9BFF"
            />
          </g>
        </svg>
      </span>
      <h2
        class="header-title"
        [class.primary-font-semibold]="theme() === GbTheme.ThemeOne"
        [class.primary-font-medium]="theme() === GbTheme.ThemeTwo"
      >
        @if (activeTab() === TabTypes.Language) {
          <span>{{ 'language.select_language' | translate }}</span>
        } @else {
          <span>{{ 'currency.choose_currency' | translate }}</span>
        }
      </h2>
    </div>

    <div class="selected-language-currency-cross-container">
      <div class="selected-language-currency-container primary-font-medium">
        <div class="selected-language-container">
          <span>
            <img
              [src]="subscriberService.subscriberLanguage().flagUrl"
              [alt]="'Flag of ' + subscriberService.subscriberLanguage().code | uppercase"
              width="34"
              height="24"
            />
          </span>
          <span>{{ subscriberService.subscriberLanguage().code | uppercase }}</span>
        </div>
        <span>-</span>
        <div class="selected-currency-container">
          <span>{{ subscriberService.subscriberCurrency().currency | uppercase }}</span>
          (<span
            [innerHtml]="subscriberService.subscriberCurrency().currency | currencySymbol"
          ></span
          >)
        </div>
      </div>
      <button type="button" class="default-button" (click)="closeModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M6.71057 3.63708L12.9242 9.81308L19.1057 3.66908C19.2422 3.52463 19.4067 3.40907 19.5893 3.32934C19.7718 3.24961 19.9687 3.20734 20.1681 3.20508C20.5951 3.20508 21.0045 3.37365 21.3064 3.67371C21.6083 3.97377 21.7779 4.38073 21.7779 4.80508C21.7816 5.00124 21.745 5.1961 21.6703 5.37769C21.5955 5.55928 21.4842 5.72377 21.3432 5.86108L15.0813 12.0051L21.3432 18.2291C21.6086 18.4871 21.7641 18.8364 21.7779 19.2051C21.7779 19.6294 21.6083 20.0364 21.3064 20.3364C21.0045 20.6365 20.5951 20.8051 20.1681 20.8051C19.963 20.8135 19.7583 20.7795 19.5671 20.7051C19.3759 20.6308 19.2023 20.5177 19.0574 20.3731L12.9242 14.1971L6.72667 20.3571C6.59065 20.4967 6.42816 20.6082 6.24858 20.6851C6.06899 20.762 5.87586 20.8028 5.68033 20.8051C5.2534 20.8051 4.84395 20.6365 4.54206 20.3364C4.24017 20.0364 4.07057 19.6294 4.07057 19.2051C4.06682 19.0089 4.10344 18.8141 4.17818 18.6325C4.25292 18.4509 4.36421 18.2864 4.50521 18.1491L10.7672 12.0051L4.50521 5.78108C4.2399 5.52309 4.08432 5.17374 4.07057 4.80508C4.07057 4.38073 4.24017 3.97377 4.54206 3.67371C4.84395 3.37365 5.2534 3.20508 5.68033 3.20508C6.06667 3.20988 6.43691 3.36508 6.71057 3.63708Z"
            fill="black"
          />
        </svg>
      </button>
    </div>
  </div>
  <div class="modal-body p-0">
    <div class="modal-body-header d-none d-md-flex gap-3">
      <span class="header-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
        >
          <path
            d="M17.6866 4.25C17.9491 4.25018 18.1836 4.41442 18.2735 4.66113L20.6807 11.2812H26.1241C26.3866 11.2814 26.6211 11.4457 26.711 11.6924L29.2959 18.8018C29.3461 18.9397 29.3461 19.0915 29.2959 19.2295L26.711 26.3389C26.6211 26.5856 26.3866 26.7498 26.1241 26.75H10.5791C10.1454 26.75 9.84303 26.3187 9.99125 25.9111L12.2432 19.7188H2.14164C1.70792 19.7188 1.40553 19.2875 1.55375 18.8799L3.98344 12.1982C4.03361 12.0603 4.03361 11.9085 3.98344 11.7705L1.55375 5.08887C1.40553 4.68125 1.70792 4.25 2.14164 4.25H17.6866Z"
            fill="white"
          />
          <g style="mix-blend-mode: multiply">
            <path
              d="M1.55494 5.08859C1.40672 4.68097 1.70858 4.25 2.14231 4.25H17.6872C17.9501 4.25 18.1848 4.41442 18.2746 4.66141L20.8598 11.7708C20.91 11.9088 20.91 12.06 20.8598 12.198L18.2746 19.3073C18.1848 19.5543 17.9501 19.7188 17.6872 19.7188H2.14231C1.70858 19.7188 1.40672 19.2878 1.55494 18.8802L3.98483 12.198C4.035 12.06 4.035 11.9088 3.98483 11.7708L1.55494 5.08859Z"
              class="primary-path"
              fill="#3D38D0"
            />
          </g>
          <g style="mix-blend-mode: multiply">
            <path
              d="M9.99244 12.1198C9.84422 11.7122 10.1461 11.2812 10.5798 11.2812H26.1247C26.3876 11.2812 26.6223 11.4457 26.7121 11.6927L29.2973 18.802C29.3475 18.94 29.3475 19.0912 29.2973 19.2292L26.7121 26.3386C26.6223 26.5856 26.3876 26.75 26.1247 26.75H10.5798C10.1461 26.75 9.84422 26.319 9.99244 25.9114L12.4223 19.2292C12.4725 19.0912 12.4725 18.94 12.4223 18.802L9.99244 12.1198Z"
              class="primary-medium"
              fill="#9E9BFF"
            />
          </g>
        </svg>
      </span>
      <h2
        class="header-title"
        [class.primary-font-semibold]="theme() === GbTheme.ThemeOne"
        [class.primary-font-medium]="theme() === GbTheme.ThemeTwo"
      >
        @if (activeTab() === TabTypes.Language) {
          <span>{{ 'language.select_language' | translate }}</span>
        } @else {
          <span>{{ 'currency.choose_currency' | translate }}</span>
        }
      </h2>
    </div>
    <div class="language-currency-settings-content">
      @switch (activeTab()) {
        @case (TabTypes.Language) {
          <app-select-language (languageSelected)="closeModal()" />
        }
        @case (TabTypes.Currency) {
          <app-select-currency (currencySelected)="closeModal()" />
        }
      }
    </div>
  </div>
</div>
